<template>
  <v-container class="content">
    <template>
      <v-card class="card-success" style="min-height: 60vh">
        <div v-if="loading" style="height: 60vh">
          <v-row
            class="fill-height ma-2 flex-column"
            align="center"
            justify="center"
          >
            <v-progress-circular :size="70" color="primary" indeterminate />
          </v-row>
        </div>
        <div v-if="!loading">
          <v-form
            id="form"
            ref="form"
            v-model="valid"
            class="pa-3"
            @submit.prevent="updateProfile"
          >
            <v-card>
              <v-list-item-content>
                <v-card-title class="headline mx-auto">
                  Dados Pessoais
                </v-card-title>
                <v-row class="pa-3">
                  <v-col cols="6">
                    <v-text-field
                      v-model="form.nome"
                      label="Nome *"
                      :rules="requiredRules"
                    />
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      v-model="form.cpf"
                      v-mask="maskCpf"
                      label="CPF *"
                      :rules="requiredRules"
                      return-masked-value
                    />
                  </v-col>
                  <v-col cols="6">
                    <v-autocomplete
                      v-model="form.estado"
                      label="Estado *"
                      name="user_estado"
                      :rules="requiredRules"
                      :items="estado"
                      item-text="nome"
                      item-value="id"
                      @change="changeCidade"
                    />
                  </v-col>
                  <v-col cols="6">
                    <v-autocomplete
                      v-model="form.cidade"
                      label="Cidade *"
                      :rules="requiredRules"
                      :items="cidade"
                      item-text="nome"
                      item-value="id"
                      :disabled="disableCidade"
                    />
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      v-model="form.endereco"
                      label="Endereço *"
                      :rules="requiredRules"
                    />
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      v-model="form.telefone"
                      v-mask="maskTelFixo"
                      label="Telefone *"
                      type="tel"
                      :rules="requiredRules"
                      return-masked-value
                    />
                  </v-col>
                </v-row>
                <v-card-title class="headline mx-auto">
                  Dados de Acesso
                </v-card-title>
                <v-row class="pa-3">
                  <v-col cols="12">
                    <v-text-field
                      v-model="form.email"
                      label="Email *"
                      :rules="emailRules"
                      return-masked-value
                    />
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      v-model="form.senha"
                      :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="show ? 'text' : 'password'"
                      name="senha1"
                      label="Senha *"
                      :rules="requiredRules"
                      counter
                      @click:append="show = !show"
                    />
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      v-model="form.senhaConfirme"
                      :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                      :rules="pwdConfirm"
                      :type="show1 ? 'text' : 'password'"
                      name="senha2"
                      label="Confirme sua Senha *"
                      counter
                      @click:append="show1 = !show1"
                    />
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-card>
            <v-btn
              type="submit"
              :disabled="salvando"
              :loading="salvando"
              color="success"
              form="form"
            >
              Atualizar Informações
            </v-btn>

            <router-link
              :disabled="salvando"
              to="/index-agroindustria/dashboard"
            >
              <v-btn :disabled="salvando" color="error" class="ml-3">
                Cancelar
              </v-btn>
            </router-link>
          </v-form>
        </div>
      </v-card>
    </template>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      salvando: false,
      loading: true,
      valid: null,
      show: false,
      show1: false,
      maskCpf: '###.###.###-##',
      maskTelFixo: '(##) #####-####',
      emailRules: [v => /.+@.+/.test(v) || 'E-mail invalido'],
      requiredRules: [v => !!v || '* Obrigatório'],
      pwdConfirm: [
        v => !!v || 'Confirme sua senha',
        v => v === this.form.senha || 'Senhas não conferem.',
      ],
      disableCidade: '',
      userData: '',
      form: {
        userId: '',
        nome: '',
        cpf: '',
        email: '',
        cidade: '',
        estado: '',
        endereco: '',
        telefone: '',
        senha: '',
        senhaConfirme: '',
      },
      senhaForm: '',
      estado: [{nome: 'Carregando', id: 0}],
      cidade: [{nome: 'Carregando', id: 0}],
    }
  },

  created() {
    this.userData = JSON.parse(localStorage.getItem('user'))
    this.form.userId = this.userData.id
    this.form.nome = this.userData.nome
    this.form.cpf = this.userData.cpf
    this.form.endereco = this.userData.endereco
    this.form.telefone = this.userData.telefone
    this.form.email = this.userData.email
    if (this.userData.estado === null) {
      this.loadEstado()
    } else {
      this.loadEstadoEdit(this.userData.estado, this.userData.cidade)
    }
  },
  methods: {
    updateProfile() {
      this.$refs.form.validate()
      if (!this.valid) {
        this.Swal.fire(
          'Atenção',
          'Preencha os itens obrigatórios sinalizados com ("*").',
          'warning',
        )
      } else {
        this.salvando = true
        this.alert = false
        if (this.form.estado.id != null) {
          this.form.estado = this.form.estado.id
        }
        if (this.form.cidade.id != null) {
          this.form.cidade = this.form.cidade.id
        }
        this.api
          .put('/atualizar-perfil', this.form)
          .then(response => {
            this.salvando = false
            if (response.data.error) {
              let erros = ''
              response.data.message.forEach(el => {
                erros += el + '<br/>'
              })
              this.Swal.fire({
                title: 'Corrija os erros abaixo:',
                icon: 'warning',
                html: erros,
              })
            } else {
              this.userData.nome = this.form.nome
              this.userData.cpf = this.form.cpf
              if (this.form.estado.id != null) {
                this.form.estado = this.form.estado.id
                this.form.cidade = this.form.cidade.id
              } else {
                this.userData.cidade = this.form.cidade
                this.userData.estado = this.form.estado
              }
              this.userData.endereco = this.form.endereco
              this.userData.telefone = this.form.telefone
              this.userData.email = this.form.email
              this.userData.senha = this.form.senha
              localStorage.setItem('user', JSON.stringify(this.userData))
              this.Swal.fire('Sucesso', 'Atualização Realizada', 'success')
              this.$router.push({name: 'Diagnósticos'})
            }
          })
          .catch(error => {
            this.salvando = false
            this.Swal.fire({
              title: 'Atenção:',
              icon: 'warning',
              html: error,
            })
          })
      }
    },
    loadEstado() {
      this.api('/estado')
        .then(response => {
          this.estado = response.data.estado
          this.loading = false
        })
        .catch(error => {
          this.message = error
          // console.log(this.message)
        })
    },
    loadCidade(CodEstado) {
      this.api('/cidade', {
        params: {
          CodEstado: CodEstado,
        },
      })
        .then(response => {
          this.cidade = response.data.cidade
          this.disableCidade = false
        })
        .catch(error => {
          this.message = error
          // console.log(this.message)
        })
    },
    changeCidade() {
      this.loadCidade(this.form.estado)
    },
    loadEstadoEdit(CodEstado, CodCidade) {
      this.api('/estado')
        .then(response => {
          this.estado = response.data.estado
          this.form.estado = this.estado
          this.form.estado = this.form.estado[CodEstado - 1]
          this.loadCidadeEdit(CodCidade)
        })
        .catch(error => {
          this.message = error
          // console.log(this.message)
        })
    },
    loadCidadeEdit(CodCidade) {
      this.api('/cidade')
        .then(response => {
          this.cidade = response.data.cidade
          this.form.cidade = this.cidade
          this.form.cidade = this.form.cidade[CodCidade - 1]
          this.disableCidade = false
          this.loading = false
        })
        .catch(error => {
          this.message = error
          // console.log(this.message)
        })
    },
  },
}
</script>
